import styled from 'styled-components'

export const UploadContainer = styled.div`
  padding: 12px;
  background: ${({ theme }) => theme.colors.background.primary};
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
`

export const UploadArea = styled.div`
  border: 2px dashed ${({ theme }) => theme.colors.border.default};
  border-radius: 10px;
  padding: 26px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  background: ${({ theme }) => theme.colors.background.secondary};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.primaryLight};
  }

  &:focus-visible {
    outline: none;
    box-shadow: ${({ theme }) => theme.shadows.focus};
  }

  &.drag-over {
    border-color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.primaryLight};
    transform: scale(1.01);
  }
`

export const UploadIcon = styled.div`
  width: 38px;
  height: 38px;
  margin: 0 auto 12px;
  color: ${({ theme }) => theme.colors.primary};

  svg {
    width: 100%;
    height: 100%;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    fill: none;
  }
`

export const UploadContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`

export const UploadText = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};
`

export const UploadHint = styled.div`
  font-size: 10px;
  color: ${({ theme }) => theme.colors.text.secondary};
`
